<template>
  <!-- Interesting & Useful Blogs section -->
  <section class="useful-blog-section">
    <div class="container">
      <div class="section-heading section-heading-four">
				<div class="row row-gap-3">
					<div class="col-md-6 aos" data-aos="fade-up">
						<h2>Interesting & Useful Blogs</h2>
						<p>Here’s a compelling blog description designed to provide a clear idea</p>
					</div>
					<div class="col-md-6 text-md-end aos" data-aos="fade-up">
						<router-link to="/blogs/blog-list" class="btn btn-primary btn-view">View all Blogs<i
								class="feather-arrow-right"></i></router-link>
					</div>
				</div>
			</div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel useful-four-slider common-four-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexfourblog" :key="item.id">
                <div class="service-widget aos" data-aos="fade-up">
                  <div class="service-img">
                    <router-link to="/blogs/blog-details">
                      <img :src="require(`@/assets/img/catering/${item.image}`)" class="img-fluid serv-img" alt="Service Image">
                    </router-link>
                  </div>
                  <div class="service-content service-four-blogs text-start">
                    <div class=" border-bottom mb-3">
                      <h3 class="title mb-1">
                        <router-link to="/blogs/blog-details" class="text-truncate">{{item.title}}</router-link>
                      </h3>
                      <p class="mb-3">{{item.text}}</p>
                    </div>
                    <div class="usefull-bottom">
                      <div class="d-flex align-items-center">
                        <span class="useful-img avatar avatar-lg me-2">
                          <router-link to="/customer-settings/account-settings" class="text-truncate"><img :src="require(`@/assets/img/profiles/${item.avatar}`)" class="rounded-circle" alt="User"></router-link>
                        </span>
                        <span class="fs-14">{{ item.name }}</span>
                      </div>
                      <div>
                        <span class="fs-14"><i class="ti ti-calendar me-1"></i>09 Aug 2025</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Interesting & Useful Blogs section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexfourblog from "@/assets/json/indexfourblog.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexfourblog: indexfourblog,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
